import React from 'react';

export default function Toast({ message, type = 'error' }) {
  return (
    <div className={`toast ${type}`}>
      {message}
    </div>
  );
}
